import { startOfWeek } from 'date-fns';

import { TaxTypeEnum } from '@/types/graphql';

export const KeyNames = {
  Down: 'ArrowDown',
  Enter: 'Enter',
  Escape: 'Escape',
  Left: 'ArrowLeft',
  Right: 'ArrowRight',
  Space: ' ',
  Up: 'ArrowUp',
};

export const LONG_DATE_FORMAT = 'eee, MMMM d, yyyy';
export const NOT_AVAILABLE_TEXT = 'N/A';
export const STATE_RECIPROCITY = ['DC', 'MD', 'VA'];
export const STRICT_TIME_POLICY_INFO =
  'Enable this setting to prevent timesheets from being auto-approved if they exceed the specified time policy criteria.';
export const STRICT_LOCATION_POLICY_INFO =
  'Enable this setting to match the check-out radius with the check-in radius and require manual approval for timesheets outside this radius.';
export const ENABLE_CONTACT_NUMBER_TIMESHEET_INFO =
  'Show GravyWorkers contacts in the exported timesheet.';
export const ENABLE_CHECKIN_CHECKOUT_REMINDERS_INFO =
  'Turn off for clients using onsite timekeeping or in low-signal areas.';
export const TAX_TYPE_LABELS = {
  [TaxTypeEnum.TAX_W2]: 'W2',
  [TaxTypeEnum.ALL]: 'All',
};

export const JOB_TAX_TYPES = {
  w2: 'w2',
  1099: '1099',
  all: 'all',
};

export const MONDAY = 1;

export const DAY_HOURS = 24;

export const MONDAY_OF_WEEK = startOfWeek(new Date(), { weekStartsOn: MONDAY });

export const MONDAY_OF_WEEK_UTC = new Date(
  Date.UTC(
    MONDAY_OF_WEEK.getFullYear(),
    MONDAY_OF_WEEK.getMonth(),
    MONDAY_OF_WEEK.getDate(),
  ),
);

export const ERROR_SUPPORT_MESSAGE =
  'Something went wrong, please contact support';

export const EXTERNAL_URL = {
  w2: 'https://console.checkhq.com/companies/{0}/employees/{1}/employee-info',
  1099: 'https://console.checkhq.com/companies/{0}/contractors/{1}/contractor-details',
};

export const CONFIRM_MSG = 'Are you sure you wants to save this information?';
export const LOW_MARKUP_WARNING_DESCRIPTION =
  'The configured markup appears low. We recommend seeking approval from the Sales team.';
export const DEFAULT_MARKUP_PRICE_VALUE = 60;
export const MARKUP_PERCENTAGE_FIELD_ERROR = 'Markup percentage cannot be zero';
export const CONFIGURABLE_CHECKIN_FIELD_ERROR =
  'Please enter a value between 250 ft - 10,000 ft';
export const CONFIGURABLE_SCRUTINY_CHECKOUT_TIME_ERROR =
  'Please enter a value between 1 - 120 minutes';
// GRAVY-10804. This used to read "will only apply to future job postings. To
// update badge requirements for current open jobs, please adjust badge settings
// directly within each job's details" — the opposite of what the server does.
//
// `SaveCustomerCertificate#update_upcoming_jobs_badges` re-derives
// `@customer.jobs.active.not_started` on every save and applies the new set to
// ALL of them, deletes the rows for anything removed, then fires
// MatchingJobsNotifierWorker for every job it touched. So the old copy sent an
// admin off to edit jobs the save had already changed, and hid the fact that
// workers get re-notified.
//
// The cascade is the useful behaviour — a client-level requirement that ignored
// open jobs would surprise in the other direction — so the copy is what changed,
// not the code. State the blast radius before they confirm.
export const CLIENT_BADGE_UPDATED =
  'Saving this applies the change to every upcoming job for this client, not just future ones — including jobs that are already open. Removing a badge here also removes it from those jobs, and matching workers are re-notified.';

export const PullToRefreshScreens = {
  includesList: [
    '/',
    '/clients',
    '/orders',
    '/contacts',
    '/workers',
    '/job-monitor',
    '/reports',
  ],
  startsWithList: ['/invoices'],
};

export const taxOptions = [TaxTypeEnum.ALL, TaxTypeEnum.TAX_W2];

export const allowedStates = ['VA', 'DC', 'MD', 'FL'];

export const isNullOrEmpty = (value) => {
  return value === null || value === undefined || value === '';
};

export const EventEmitterTopics = {
  RELEASE_NOTES_PUBLISHED: 'RELEASE_NOTES_PUBLISHED',
};
